import { createQueryKeys, type inferQueryKeys } from '@lukemorales/query-key-factory';
import { getDailyCheckInRound } from './mapper/getDailyCheckInRound';

export const dailyCheckInQueryKey = createQueryKeys('dailyCheckIn', {
  currentRound: {
    queryFn: async () => {
      const response = await getDailyCheckInRound();

      return response;
    },
    queryKey: null,
  },
});

export type DailyCheckInQueryKey = inferQueryKeys<typeof dailyCheckInQueryKey>;
